module.exports = __webpack_public_path__ + "static/media/editPen.94b649d1.svg";